<template>
	<!-- 上传license -->
		<el-dialog
		 :modal-append-to-body="false"
		  title="license管理"
		  :visible.sync="dialogVisible"
		  @close="close"
		  width="500px">
			<div class="brandMessage">
				<span>品牌标识：{{brandLabel}}</span>
				<span>品牌名称：{{brandName}}</span>
			</div>
			<div class="licenseStatus">license状态：{{status}}</div>
			<div class="licenseTime">license有效时间: {{licenseTime}}</div>
			<div class="ipRange">IP范围：{{ipRange}}</div>
			<div clase="licenseData">
				<el-table
					class="table"
					size="small"
		      :data="moduleData"
		      style="width: 100%">
		      <el-table-column
		        prop="name"
		        label="品牌权限"
		        width="100">
		      </el-table-column>
		      <el-table-column
		        prop="durationTime"
		        label="模块有效时间">
		        <template slot-scope="scope">
		        	{{scope.row.durationTime[0]}}~
		        	{{scope.row.durationTime[1]}}
		        </template>
		      </el-table-column>
		      <el-table-column
		        prop="num"
		        label="人数"
		        width="50">
		      </el-table-column>
		    </el-table>
			</div>
		  <el-upload
			  class="upload_file"
			  :http-request="httpRequestFile"
			  accept=".ocs"
			  action=""
			  :show-file-list="false"
			  :on-preview="handlePreview"
			  :on-remove="handleRemove"
			  :before-remove="beforeRemove"
			  :on-exceed="handleExceed">
		 		<el-button size="small">{{"上传license文件"}}</el-button>
			  <div v-if="uploadState" class="error_text">
			  	{{uploadState}}
			  </div>
			  <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
			</el-upload>
		</el-dialog>
</template>

<script>
import {
	Decrypt
} from '@/utils/crypto';

export default {
	name: "uploadLicense",
	data() {
		return {
			queryKeys: ["lc","ph","sm","em","wb","ln"],
			dialogVisible	: false,
			brandLabel: "--",
			brandName: "--",
			status: "--",
			ipRange: "--",
			uploadState: "",
			licenseTime: "--",
			// 模块权限列表
			moduleData: [{
				name: "IM",
				id: 1,
				checked: false,
				durationTime: [],
				num: "--"
			},{
				name: "电话",
				id: 2,
				checked: false,
				durationTime: [],
				num: "--"
			},{
				name: "短信",
				id: 3,
				checked: false,
				durationTime: [],
				num: "--"
			},{
				name: "邮件",
				id: 4,
				checked: false,
				durationTime: [],
				num: "--"
			},{
				name: "微博",
				id: 5,
				checked: false,
				durationTime: [],
				num: "--"
			},{
				name: "培训",
				id: 6,
				checked: false,
				durationTime: [],
				num: "--"
			}],
			tableData: [],
			/*tableData: [{
          id: 1,
          licenseName: 'IM',
          validTime: '2020-20-20 - 2020-20-20',
          num: 10
        }]*/
		}
	},
	mounted(){
	},
	methods: {
		openUpload(label,name){
			this.brandLabel = label;
			this.brandName = name;
			this.requestLicense();
			this.dialogVisible = true;
		},

		// 获取license信息
		requestLicense() {
			this.$api.ocsLicenseGet(this.brandLabel).then(res=>{
    		if(res.errcode != 0) return false;
    		const { licenseContent,message } = res.data;
    		this.status = message;

    		if(!licenseContent) {
    			this.resetLicenseItem();
    		}else{
    			this.setLicenseItem(licenseContent);
    		}

    	})
		},
		// 设置license勾选项
    setLicenseItem(licenseContent){
    	// 解密
  		for(let key in licenseContent){
  			licenseContent[key] = Decrypt(licenseContent[key]);
  		}
  		console.log(licenseContent);
  		// 设置授权项
  		for(let i = 0; i < this.queryKeys.length; i++){
  			let itemKey = this.queryKeys[i];
  			if(typeof(licenseContent[itemKey]) != "undefined"){
  				this.moduleData[i].checked = true;
  				this.moduleData[i].durationTime = [licenseContent[itemKey+"St"],licenseContent[itemKey+"Et"]];
  				this.moduleData[i].num = licenseContent[itemKey];
  			}else{
  				this.moduleData[i] = this.$options.data().moduleData[i];
  			}
  		}

  		this.ipRange = licenseContent.ipArea;
  		this.licenseTime  = `${licenseContent.startTime||""}~${licenseContent.endTime||""}`;
    },
		resetLicenseItem(){
			this.status = this.$options.data().status;
			this.ipRange = this.$options.data().ipRange;
			this.licenseTime = this.$options.data().licenseTime;
    	this.moduleData = this.$options.data().moduleData;
    },
		// 上传license
		httpRequestFile (file) {
			const that = this
			const formData = new FormData();
			formData.append('file', file.file);
			// 调用上传方法
			this.$api.oscLicenseUpload(this.brandLabel,formData).then(res => {
				if(res.errcode != 0) return;
				console.log(res);
				that.$message.success(res.errmsg);
				this.uploadState = "";
			}).catch((error)=>{
				this.uploadState = "上传失败,请重新上传license";
			}).finally(()=>{
				this.requestLicense();
			});
		},
		handleRemove(file, fileList) {
        console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`只能上传单个license`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    close(){
    	Object.assign(this.$data, this.$options.data.call(this));
    }
	}
}	
</script>

<style lang='scss' scoped>
.brandMessage{
	margin-bottom: 10px;
	span + span {
		margin-left: 21px;
	}
}
.licenseStatus,
.ipRange,
.licenseTime{
	margin-bottom: 10px;
}
.table{
	::v-deep.el-table__row>td{
		border: none;
	}
	::v-deep.el-table__header-wrapper th{
		border: none;
	}
}
.licenseData{
	margin-bottom: 10px;
}
.upload_file{
	padding-top: 10px;
	::v-deep.el-upload {
    width: 100%;
  }
}
.btn_box{
	text-align: center;
}
.error_text{
	color: red;
}
</style>